import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { ChipInterface } from 'app/module/chip.interface';
import { OperadoraInterface } from 'app/module/operadora-interface';

@Injectable({
	providedIn: 'root'
})
export class OperadoraService {
	private url: string = environment.g2e_api;

	private httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json; charset=UTF-8',
			'Authorization': 'Bearer ' + localStorage.getItem("tokenApiG2E")
		}),
	}

	constructor(private http: HttpClient) { }

	public get(): Observable<OperadoraInterface[]> {
		return this.http.get<OperadoraInterface[]>(`${this.url}operadora`, this.httpOptions).pipe(
			(res) => res,
			(error) => error
		);
	}

	// public getOne(id: number): Observable<PlanoInterface> {
	// 	return this.http.get<PlanoInterface>(`${this.url}plano/${id}`, this.httpOptions).pipe(
	// 		(res) => res,
	// 		(error) => error
	// 	);
	// }

	// public post(data: PlanoInterface): Observable<PlanoInterface> {
	// 	return this.http
	// 		.post<any>(`${this.url}plano/create`, data, this.httpOptions)
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }

	// public put(data: PlanoInterface): Observable<PlanoInterface> {
	// 	return this.http.put<any>(`${this.url}plano/${data.id_plano}`, data, this.httpOptions)
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }

	// public delete(data: number, id: number): Observable<any> {
	// 	return this.http
	// 		.put<any>(`${this.url}sistema/${id}/update`, {
	// 			id_sistema: id,
	// 			isDeleted: data,
	// 		})
	// 		.pipe(
	// 			(res) => res,
	// 			(error) => error
	// 		);
	// }
}
